import styled from 'styled-components'

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  cursor: pointer;
`

export const Switch = styled.div`
  position: relative;
  width: 32px;
  height: 18px;
  background: #b3b3b3;
  border-radius: 32px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 35px;
    top: 50%;
    left: 2px;
    background: white;
    transform: translate(0, -50%);
  }
`

export const Input = styled.input`
  display: none;

  &:checked + ${Switch} {
    background: #0072bf;

    &:before {
      transform: translate(14px, -50%);
    }
  }
`
